import { render } from "./readMoreArticle.vue?vue&type=template&id=041e380c&ts=true"
import script from "./readMoreArticle.vue?vue&type=script&lang=ts"
export * from "./readMoreArticle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__